import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BudgetsService } from 'src/app/module/budgets/services/budgets.service';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';
import { InvoiceService } from 'src/app/module/invoices/invoice-service/invoice.service';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-view-edit-common',
  templateUrl: './view-edit-common.component.html',
  styleUrls: ['./view-edit-common.component.css'],
})
export class ViewEditCommonComponent {
  rowData: any;
  columns: any[];
  triggeredColumn: any;
  printData: boolean = false;
  componentName: any;
  viewHistory: any;
  pageNumber = 0;
  pageSize = 500;
  historyLists: any;
  filters: any;
  invoiceLineItem: any;
  currentUser: any;
  userDetails: any;
  invoiceLineItemPopUp: boolean = false;
  referenceNumber: any;
  paymentStatus: any;
  updatedInvoicePayload: any;
  rejectRemarksPopUpShow: any;
  rejectRemarks: any;
  selectedLineItemRow: any;
  roleName: any;
  hideall:boolean = false;
  constructor(
    private sanitizer: DomSanitizer,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private BudgetsService: BudgetsService,
    private emsServices: InvoiceService
  ) {
    this.userDetails = JSON.parse(localStorage.getItem('user_details')!);
    this.rowData = this.config.data.rowData;
    this.columns = this.config.data.columns;
    this.triggeredColumn = this.config.data.triggeredColumn;
    this.componentName = this.config.data.componentName;
    this.viewHistory = this.config.data.viewHistory;
    this.invoiceLineItem = this.rowData?.invoiceLineItem || [];

    console.log('Row Data:', this.rowData);

    this.rowData?.approvalUser?.filter((user: any) => {
      if (user?.approvalStatus == 1 && user?.viewStatus == 1) {
        this.currentUser = user;
        console.log(this.currentUser);
      }
    });
    // const userId = this.userDetails?.id;

    //     const shouldCallApi = this.rowData.invoiceLineItems.some((item:any) =>
    //       (item.approvalUser ?? []).some((user:any) =>
    //         user.userId === userId && user.approvalStatus > 1
    //       )
    //     );
    //     console.log(shouldCallApi)

    // const matchedInvoices = this.rowData?.invoiceLineItems.filter((item:any) =>
    //   item.approvalUser?.some((user:any) => user.userId === userId)
    // );

    // console.log("matchedInvoices",matchedInvoices)
  }
  get allSelectedRowsPending(): boolean {
    if (!this.selectedRows?.length || !this.userDetails?.id) {
      return false; // Return false if selectedRows is empty or userDetails.id is undefined
    }
    return this.selectedRows.every(row => {
      const user = row.approvalUser?.find((ap: any) => ap.userId === this.userDetails?.id);
      return user?.approvalStatus !== 1;
    });
  }
  
  columnPairs: any[][] = [];

  ngOnInit(): void {
    if (this.viewHistory && this.componentName === 'Budget') {
      this.filters = this.setFilter();
      this.getList();
    }
    this.userDetails?.userRole.filter((role: any) => {
      if (role?.roleName == 'ROLE_FINANCE_CORPORATE' || role?.roleName == 'ROLE_FINANCE_MANPOWER' || 
        role?.roleName == 'ROLE_FINANCE_PETTYCASH' ||  role?.roleName == 'ROLE_FINANCE_PAYMENT_CHECKER'||  role?.roleName == 'ROLE_SUPERUSER'
      ) {
        this.roleName = role.roleName
        console.log("roleName",this.roleName)
      }
    });

    this.setColumnPairs();

  }
  setColumnPairs() {
    this.columnPairs = [];
    for (let i = 0; i < this.columns.length; i += 2) {
      this.columnPairs.push([this.columns[i], this.columns[i + 1]]);
    }
  }

  closeDialog() {
    this.ref.close(this.roleName);
  }

  getColumnPairs(columns: any[]): any[][] {
    const pairs = [];
    for (let i = 0; i < columns.length; i += 2) {
      pairs.push([columns[i], columns[i + 1]]);
    }
    return pairs;
  }

  isArrayOfObjects(value: any): boolean {
    return (
      Array.isArray(value) && value.length > 0 && typeof value[0] === 'object'
    );
  }

  getFormattedValue(key: any): any {
    if (!this.rowData || !this.rowData[key]) return '';

    const value = this.rowData[key];
    if (key === 'status') {
      return value == 1 ? 'Active' : 'Inactive';
    }

    if (key === 'invoiceUrl') {
      return '';
    }

    if (this.isArrayOfObjects(value)) {
      if (key === 'expenseAssociated') {
        return value.map((obj: any) => obj.expense).join(', ');
      } else if (key === 'userRole') {
        return value.map((obj: any) => obj.roleDescription).join(', ');
      } else if (key === 'warehouseList') {
        return value
          .map((obj: any) => obj.clientName + ' - ' + obj.warehouseName)
          .join(', ');
      } else if (
        value.map(
          (el: any) => el.invoiceLineItemExpense?.attributeName === 'Invoice No'
        ) &&
        this.columns.some((el: any) => el.header !== 'Expenses')
      ) {
        return this.getInvoiceNumbers(value);
      } else if (key === 'invoiceLineItems') {
        return value.map((obj: any) => obj.expense);
      }

      // else if (key === 'invoiceLineItems') {
      //   return this.getInvoiceNumbers(value);
      // }
      return value.map((obj: any) => this.getDisplayValue(obj)).join(', ');
    }

    return value;
  }

  getInvoiceNumbers(lineItems: any[]): string {
    if (!lineItems) return '';

    const invoiceNumbers: string[] = [];
    lineItems.forEach((lineItem) => {
      const invoiceAttr = lineItem.invoiceLineItemExpense?.find(
        (attr: any) => attr.attributeName === 'Invoice No'
      );
      if (invoiceAttr?.attributeValue) {
        invoiceNumbers.push(invoiceAttr.attributeValue);
      }
    });
    return invoiceNumbers.join(', ');
  }

  getDisplayValue(obj: any): string {
    return obj?.name || obj?.label || JSON.stringify(obj);
  }

  setFilter() {
    const obj = [];
    if (this.componentName === 'Budget') {
      obj.push({
        key: 'BUDGET_IN',
        value: this.rowData.id,
      });
    }
    return obj;
  }

  getList() {
    this.historyLists = [];
    this.BudgetsService.getBudgetTransactions(
      this.filters,
      this.pageNumber,
      this.pageSize
    ).subscribe(
      (data: any) => {
        if (data) {
          this.historyLists = data?.responseObject?.content;
          this.historyLists = this.historyLists.map((el: any) => ({
            status: 'Rs. ' + el?.approvedBudget,
            date: el.createdAt,
            icon: 'pi pi-wallet',
            color: '#607D8B',
            remarks: el.remarks,
          }));
        }
      },
      (err) => {
        // console.log(err);
        this.historyLists = [];
      }
    );
  }

  approveLineItem(row: any, action: any) {
    console.log(row);
    // 1. Get current user
    const user = row.approvalUser.find(
      (ap: any) => ap.userId === this.userDetails?.id
    );

    if (user) {
      // 2. Update approvalStatus
      if (action == 'approve') {
        user.approvalStatus = 2;
      }
      if (action == 'reject') {
        this.invoiceLineItemPopUp = true;
        user.approvalStatus = 3;
      }
      // 3. Remove current user from the list
      const others = row.approvalUser.filter(
        (ap: any) => ap.userId !== this.userDetails?.id
      );
      // 4. Recreate the final user array with updated one
      const finalUserList = [...others, user];

      // 5. Create payload with final user list
      const payload1 = {
        id: row.id,
        approvalUser: finalUserList,
      };

      const payload = {
        id: row.id,
        currentApprovalUserLineId: this.currentUser?.id,
        currentApprovalUserId: this.currentUser?.userId,
        approvalUser: finalUserList,
      };
      console.log(payload);
      this.emsServices.approveInvoiceLineItem(payload).subscribe((res: any) => {
        if (res) {
          console.log(res);
          this.getInvoiceList();
          // this.ref.close(res);
        }
      });

      // const user2 = this.rowData?.approvalUser.find((user: any) => {
      //   return user?.approvalStatus === 1 && user?.viewStatus === 1;
      // });
      // const dataToSend = {
      //   id: user2.id ? user2.id : this.rowData?.id,
      //   approvalStatus: 1,
      //   budgetId: row?.budgetId,
      // }
      // if(action == 'approve'){
      //   dataToSend.approvalStatus = 2
      // }else if(action == 'reject'){
      //   dataToSend.approvalStatus = 3
      // }else if(action == 'comment'){
      //   dataToSend.approvalStatus = 4
      // }
      // console.log(dataToSend)

      // const shouldCallApi = this.rowData.invoiceLineItems.some((item:any) =>
      //   (item.approvalUser ?? []).some((user:any) =>
      //     user.userId === this.userDetails?.id && user.approvalStatus > 1
      //   )
      // );
      // console.log(shouldCallApi)

      //   const userId = this.userDetails?.id;
      //   const matchingApprovalUsers = this.rowData.invoiceLineItems.flatMap((item:any) =>
      //     (item.approvalUser ?? []).filter((user:any) =>
      //       user.userId === userId
      //     )
      //   );
      // console.log("matchingApprovalUsers",matchingApprovalUsers)
      // const allGreaterThanOne = matchingApprovalUsers.every((entry:any) => entry.approvalStatus > 1);
      // const allApprovalStatusSame = matchingApprovalUsers.every((item:any) => item.approvalStatus === matchingApprovalUsers[0].approvalStatus);
      // let differentVar: string | null = null;
      // if (!allApprovalStatusSame) {
      //   differentVar = 'Approval statuses are not the same';
      //   dataToSend.approvalStatus = 9
      // }

      // console.log('allGreaterThanOne',allGreaterThanOne)
      // if(allGreaterThanOne){
      //   this.emsServices.approveInvoice(dataToSend).subscribe((res: any) => {
      //     if(res){
      //       console.log(res)
      //     this.ref.close(res);

      //     }
      //   })
      // }
    } else {
      console.warn('User not found in approvalUser list');
    }
  }
  rejectLineItem(row: any, action: any) {
    console.log('reject');
    this.rejectRemarksPopUpShow = true;
    console.log(row);
    this.selectedLineItemRow = row;
  }
  rejectLineItemClick() {
    const user = this.selectedLineItemRow.approvalUser.find(
      (ap: any) => ap.userId === this.userDetails?.id
    );
    if (user) {
    user.approvalStatus = 3;
    }
    const others = this.selectedLineItemRow.approvalUser.filter(
      (ap: any) => ap.userId !== this.userDetails?.id
    );
    const finalUserList = [...others, user];
    console.log('rejectLineItem');
    const payload = {
      id: this.selectedLineItemRow.id,
      currentApprovalUserLineId: this.currentUser?.id,
      currentApprovalUserId: this.currentUser?.userId,
      approvalUser: finalUserList,
      remarks: this.rejectRemarks,
    };
    console.log('Reject Payload', payload);
    this.emsServices.approveInvoiceLineItem(payload).subscribe((res: any) => {
      if(res){
      console.log(res)
      this.getInvoiceList()
      this.rejectRemarksPopUpShow = false;
      this.rejectRemarks = ''
      // this.ref.close(res);

      }
    })
  }

  getInvoiceList() {
    // console.log("userDetails",this.userDetails?.id)
    const payload = [
      {
        key: 'INVOICE_IN',
        value: this.rowData?.id,
      },
    ];

    this.emsServices
      .getInvoiceInfo(payload, this.pageNumber, this.pageSize, 'id', 'ASC')
      .subscribe((data: any) => {
        if (data) {
          // console.log(data?.responseObject?.content[0])
          this.rowData = data?.responseObject?.content[0];
        }
      });
  }

  updateInvoice(lineitem: any, item: any) {
    this.invoiceLineItemPopUp = true;
    this.updatedInvoicePayload = {
      id: lineitem.id,
      paymentStatus: this.paymentStatus,
      referenceNumber: this.referenceNumber,
    };
   
  }
  updateInvoiceClick() {
    this.updatedInvoicePayload['paymentStatus'] = this.paymentStatus;
    this.updatedInvoicePayload['referenceNumber'] = this.referenceNumber;
    Object.keys(this.updatedInvoicePayload).forEach(key => {
      const value = this.updatedInvoicePayload[key];
      if (value === null || value === undefined || value === '') {
        delete this.updatedInvoicePayload[key];
      }
    });
    this.emsServices
      .updateInvoiceLineItem(this.updatedInvoicePayload)
      .subscribe((data: any) => {
        if (data) {
          // console.log(data?.responseObject?.content[0])
          this.getInvoiceList();
          this.invoiceLineItemPopUp = false;
          this.referenceNumber = ''
          this.paymentStatus = ''
        }
      });
  }

  getStatusText(value: string): string {
    switch (value) {
      case 'PARTIALLY_APPROVED':
        return 'Partially Approved';
      case 'WITHIN_BUDGET':
        return 'Within Budget';
      case 'OVERRUN':
        return 'Overrun';
      case 'COMMENTED':
        return 'Commented';
      case 'REJECTED':
        return 'Rejected';
      case 'CREATED':
        return 'Created';
      case 'PENDING':
        return 'Pending';
      case 'APPROVED':
        return 'Approved';
      case 'NOT_PAID':
        return 'Not Paid';
      case 'PAID':
        return 'Paid';
      case 'FULL_PAID':
        return 'Paid';
      default:
        return value;
    }
  }

  isFinanceRole(role: string): boolean {
    return [
      'ROLE_FINANCE_CORPORATE',
      'ROLE_FINANCE_MANPOWER',
      'ROLE_FINANCE_PETTYCASH',
    ].includes(role);
  }
  isApproved(status: string): boolean {
    return status === 'APPROVED' || status === 'PARTIALLY_APPROVED';
  }
  isPaymentCheckRole(role: string): boolean {
    return [
      'ROLE_FINANCE_PAYMENT_CHECKER',
    ].includes(role);

  }



  
    async downloadInvoices(data:any) {
      const zip = new JSZip();
  
      for (const item of data) {
        if (item.lineItemApprovalStatus === 'REJECTED') {
          console.log(`Skipping rejected item: ${item.expense}`);
          continue;
        }
        try {
          
          const response = await fetch(item.invoiceUrl);
          const blob = await response.blob();
          const fileName = item.invoiceUrl.split('/').pop() || 'invoice.pdf';
          const folder = zip.folder(item.expense);
          folder?.file(fileName, blob);
        } catch (err) {
          console.error('Failed to download:', err);
        }
      }
  
      zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, 'invoices.zip');
      });
    }
  getEncodedInvoiceUrl(url: string | null | undefined): SafeResourceUrl {
      if (!url) return '';
        const fixedUrl = url.replace(/#/g, '%23');
      const encodedUrl = encodeURI(url);
      return this.sanitizer.bypassSecurityTrustResourceUrl(fixedUrl );
    }



  selectedRows: any[] = [];  // Array to hold selected rows
  isAllSelected: boolean = false;
 toggleSelectAll() {
    if (this.isAllSelected) {
      this.rowData?.invoiceLineItems.forEach((row:any) => row.selected = true);
      this.selectedRows = [...this.rowData?.invoiceLineItems];
      console.log(this.selectedRows)
    } else {
      this.rowData?.invoiceLineItems.forEach((row:any) => row.selected = false);
      this.selectedRows = [];
    }
    // console.log("this.selectedRows",this.selectedRows)
    // this.selectedRowsChange.emit(this.selectedRows);
  }
  onRowSelect(row: any) {
    if (row.selected) {
      this.selectedRows = this.rowData?.invoiceLineItems.filter((r:any) => r.selected);
    } else {
      this.selectedRows = this.selectedRows.filter((r:any) => r !== row);
    }
  
    this.isAllSelected = this.rowData?.invoiceLineItems.every((r:any) => r.selected);
    // console.log("this.isAllSelected ",this.isAllSelected )
    // console.log("this.selectedRows",this.selectedRows)

  }

  approveAll(action:any){
    const payload = this.selectedRows.map((row: any) => {
        // 1. Find current user
        const user = row.approvalUser.find((ap: any) => ap.userId === this.userDetails?.id);

        if (!user) return null; // Skip if user not found

        // 2. Update approval status
        if (action === 'approve') {
          user.approvalStatus = 2;
        } else if (action === 'reject') {
          // this.invoiceLineItemPopUp = true;
          user.approvalStatus = 3;
        }

        // 3. Remove current user from the list
        const others = row.approvalUser.filter(
          (ap: any) => ap.userId !== this.userDetails?.id
        );

        // 4. Recreate the final user array with updated one
        const finalUserList = [...others, user];

        // 5. Return the payload object
        return {
          id: row.id,
          approvalUser: finalUserList,
          currentApprovalUserLineId: this.currentUser?.id,
          currentApprovalUserId: this.currentUser?.userId,
        };
      }).filter(Boolean); // Remove any `null` values from the array

    const payloadq = this.selectedRows.map(row => (
      { 
        approvalUser: '',
        id: row.id,
        currentApprovalUserLineId: this.currentUser?.id,
        currentApprovalUserId: this.currentUser?.userId,
       }
    ));

    console.log("payload",payload)

    this.emsServices.multiApproveInvoiceLineItem(payload).subscribe((res: any) => {
      if(res){
      console.log(res)
      this.getInvoiceList()
      this.rejectRemarksPopUpShow = false;
      this.rejectRemarks = ''
      this.selectedRows = []
      // this.ref.close(res);

      }
    })
    }
}

